import React from "react";
import { Link } from "react-router-dom";

const quickLinks = [
  {
    title: "Category",
    icon: "ti ti-list-details",
    path: "/category/add-new",
  },
  {
    title: "Product",
    icon: "ti ti-box",
    path: "/product/add-new",
  },
  {
    title: "Orders",
    icon: "ti ti-list-details",
    path: "/orders/all",
  },
  {
    title: "Coupon",
    icon: "ti-ticket",
    path: "/coupon/add-new",
  },
  {
    title: "Shipments",
    icon: "ti ti-list-details",
    path: "/shipments/all",
  },
  {
    title: "Customer",
    icon: "ti-users",
    path: "/customer/all",
  },
  {
    title: "Supplier",
    icon: "ti-user-check",
    path: "/suppliers/add-new",
  },
];

function AddNewCard() {
  return (
    <div className="row g-2">
      {quickLinks.map((item) => (
        <div className="col-md-2" key={item.title}>
          <Link to={item.path} className="link-item">
            <span className="link-icon">
              <i className={`ti ${item.icon}`}></i>
            </span>
            <p>{item.title}</p>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default AddNewCard;
